__turbopack_context__.v({
  "className": "noto_naskh_arabic_40cce4a7-module__tUsnKW__className",
});
